// profileAssumptionService.js

import axiosInstance from "../axiosInstance";

export const profileAssumptionService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/profile-assumption", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (searchValue, query = "", signal) => {
    try {
      let api_query = `/profile-assumption?$populate=profile`;

      // Add search value
      if (searchValue) api_query += `&item[$search]=${searchValue}`;
      if (query.length) api_query += `&${query}`;
      if (!query.includes("$sort")) {
        api_query += `&$sort[createdAt]=-1`;
      }

      const response = await axiosInstance.get(api_query, { signal });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchById: async (id, signal) => {
    try {
      let query = `/profile-assumption/${id}?$populate=profile`;
      let response = await axiosInstance.get(query, { signal });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id, signal) => {
    try {
      let response = await axiosInstance.patch(
        `/profile-assumption/${id}`,
        {
          ...data,
        },
        { signal },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/profile-assumption/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
